const twofamethodsString = [
    "sms", "email"
  ];
  
  export default twofamethodsString;
  